// src/pages/psytest/data/scoringMatrix.js
export const SCORING_MATRIX = {
  Q1: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    B: { audit: 0, tax: 0, fin_reporting: 1, fpa: 2, consulting: 0, global: 1, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 2, global: 2, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 0, consulting: 3, global: 2, forensic: 0 },
  },
  Q2: {
    A: { audit: 2, tax: 2, fin_reporting: 1, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    B: { audit: 1, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 2, global: 2, forensic: 0 },
  },
  Q3: {
    A: { audit: 1, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    B: { audit: 2, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 3, global: 2, forensic: 0 },
  },
  Q4: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 1 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 2, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 0, consulting: 2, global: 3, forensic: 0 },
  },
  Q5: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 2, consulting: 0, global: 1, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 2, global: 2, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 0, consulting: 3, global: 2, forensic: 0 },
  },
  Q6: {
    A: { audit: 0, tax: 0, fin_reporting: 1, fpa: 2, consulting: 1, global: 1, forensic: 0 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 0, consulting: 0, global: 0, forensic: 0 },
    C: { audit: 2, tax: 2, fin_reporting: 1, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    D: { audit: 1, tax: 1, fin_reporting: 0, fpa: 0, consulting: 0, global: 0, forensic: 4 },
  },
  Q7: {
    A: { audit: 0, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 1 },
    B: { audit: 2, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 1, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 3, global: 2, forensic: 0 },
  },
  Q8: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 0 },
    B: { audit: 1, tax: 2, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 2 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 1 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 3, global: 2, forensic: 1 },
  },
  Q9: {
    A: { audit: 2, tax: 1, fin_reporting: 1, fpa: 0, consulting: 0, global: 0, forensic: 2 },
    B: { audit: 2, tax: 2, fin_reporting: 0, fpa: 0, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 2, global: 2, forensic: 0 },
  },
  Q10: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 0 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 1, global: 2, forensic: 0 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 0, consulting: 2, global: 4, forensic: 0 },
  },
  Q11: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 1 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 1 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 1, global: 1, forensic: 1 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 1, consulting: 2, global: 1, forensic: 3 },
  },
  Q12: {
    A: { audit: 2, tax: 2, fin_reporting: 2, fpa: 0, consulting: 0, global: 0, forensic: 0 },
    B: { audit: 1, tax: 1, fin_reporting: 1, fpa: 1, consulting: 0, global: 0, forensic: 2 },
    C: { audit: 0, tax: 0, fin_reporting: 0, fpa: 2, consulting: 2, global: 1, forensic: 1 },
    D: { audit: 0, tax: 0, fin_reporting: 0, fpa: 0, consulting: 2, global: 3, forensic: 0 },
  },
};
